import React from 'react';
import { Renderer } from 'core/renderers';
import styles from './MyGanttRenderer.module.scss';


class MyGanttRenderer extends Renderer {
  constructor(props) {
    super(props);
    this.togglePan(true);
    this.toggleZoom(true);
    this.tasks = props.data.data.tasks || [[]];
    this.steps = props.data.data.steps || 100;
    this.timeScale = props.data.data.timeScale || 1;
    this.tickMarks = props.data.data.tickMarks || null;
    this.rowLabels = props.data.data.rowLabels;
    this.colLabel = props.data.data.colLabel ?? "Zeit";
    this.highlightedTasks = null;
  }

  componentDidMount() {
    super.componentDidMount();
  }

  componentDidUpdate() {
    super.componentDidUpdate();
    this.updateTasksIfNecessary();
    this.updateStepsIfNecessary();
    this.updateTimeScaleIfNecessary();
    this.updateTickMarksIfNecessary();
    this.highlightedTasks = this.props.data.data.highlightedTasks
  }


  updateTasks() {
    this.tasks = this.props.data.data.tasks;
  }

  updateSteps() {
    this.steps = this.props.data.data.steps;
    this.centerX = 0;
    this.centerY = 0;
  }

  updateTimeScale() {
    this.timeScale = this.props.data.data.timeScale || 1;
  }

  updateTickMarks() {
    this.tickMarks = this.props.data.data.tickMarks || null;
  }

  updateStepsIfNecessary() {
    if (this.props.data.data.steps === this.steps) {
      return;
    }
    this.updateSteps();
  }

  updateTimeScaleIfNecessary() {
    const nextScale = this.props.data.data.timeScale || 1;
    if (nextScale === this.timeScale) {
      return;
    }
    this.updateTimeScale();
  }

  updateTickMarksIfNecessary() {
    if (this.props.data.data.tickMarks === this.tickMarks) {
      return;
    }
    this.updateTickMarks();
  }

  updateTasksIfNecessary() {
    if (this.props.data.data.tasks === this.tasks) {
      return;
    }
    this.updateTasks();
  }

  removeSubscript(text) {
    return text.replace(/<sub>(.*)<\/sub>/g, '');
  }

  getSubscriptContent(text) {
    let matches = text.match(/(?<=<sub>)(.*)(?=<\/sub>)/g);
    return matches ? matches[0] : "";
  }

  generatePaleColor(seed) {
    const componentToHex = c => {
        return c.toString(16).padStart(2, '0');
    }

    const randomComponent = seed => {
        return (Math.abs(Math.sin(seed)) * 56 + 200) | 0;
    }

    let r = randomComponent(seed);
    let g = randomComponent(seed + 1);
    let b = randomComponent(seed + 2);

    return `#${componentToHex(r)}${componentToHex(g)}${componentToHex(b)}`;
}

  formatTime(value) {
    const scale = this.timeScale > 0 ? this.timeScale : 1;
    const scaledValue = value / scale;
    return Number.isInteger(scaledValue) ? scaledValue : Number(scaledValue.toFixed(2));
  }

  shouldRenderTick(index) {
    if (!this.tickMarks || this.tickMarks.length === 0) return true;
    return this.tickMarks.includes(index);
  }

  renderData() {
    this.moveX = -this.centerX;
    this.moveY = -this.centerY;

    return (<div style={{ transform: `translate(${this.moveX}px, ${this.moveY}px) scale(${this.zoom})` }}>
      <div className={styles.myGantt}>
        <div className={styles.myGanttLabelColumn}>
          {
            this.tasks.map((row, index) => {
              return (
                <div key={index} className={styles.machineLabel}>{this.rowLabels?.at(index) || `Maschine ${index+1}`}</div>
              )
            })
          }
        </div>
        <div className={styles.myGanttContentColumn}>
          {
          this.tasks.map((row, index) => {
            return (
            <div className={styles.myGanttContentValues} style={{gridTemplateColumns: Array(this.steps).fill('25px').join(' ')}} key={index}>
              {
                row.map((task, index) => {
                  return (
                    <div
                      id={task.id}
                      key={task.id}
                      className={`${styles.gridItem} ${this.highlightedTasks?.includes(task.id) ? styles.highlighted : ''}`}
                      style={{ backgroundColor: task.name === 'M' ? '#c8ffc8' : this.generatePaleColor(task.colorSeed ?? index), gridColumnStart: task.start + 1, gridColumnEnd: task.end + 1 }}
                      data-name={this.removeSubscript(task.name)}
                      data-subscript={this.getSubscriptContent(task.name)}
                      data-duration={this.formatTime(task.duration)}
                      data-start={this.formatTime(task.start)}
                      data-end={this.formatTime(task.end)}
                    >
                      <p>
                        {this.removeSubscript(task.name)}
                        <sub>
                          {this.getSubscriptContent(task.name)}
                        </sub>
                      </p>
                    </div>
                  )
                })
              }
            </div>)
          })
          }
          <div className={styles.myGanttContentLabels} style={{gridTemplateColumns: Array(this.steps+3).fill('25px').join(' ')}}>
            {
              Array(this.steps+1).fill('').map((_, index) => { 
                return (
                  <p key={`x_${index}`}>
                  {this.shouldRenderTick(index) ? this.formatTime(index) : ''}
                </p>
                )
              })
            }
            <p key={`x_empty`}></p>
            <p key={`x_label`}>
              {this.colLabel}
            </p>
          </div>
        </div>
      </div>
      
    </div>);
  }
}

export default MyGanttRenderer;

